import React, { useState } from 'react'
import ModalTitle from '@/checkout-instore-legacy/components/Commons/ModalTitle'
import Divider from '@vtex/styleguide/lib/Divider'
import { FormattedMessage } from 'react-intl'
import Button from '@vtex/styleguide/lib/Button'
import Toggle from '@vtex/styleguide/lib/Toggle'
import Textarea from '@vtex/styleguide/lib/Textarea'
import { ToastConsumer } from '@vtex/styleguide/lib/ToastProvider'
import { useIntl } from '@/checkout-instore-legacy/hooks/intl'
// TODO: this error popped up when moving the checkout-instore project
// to checkout-instore-legacy, but needs to be fixed at some point
// @ts-ignore
import { CopyToClipboard } from 'react-copy-to-clipboard'
import QRCode from 'qrcode.react'
import { getIntlMessage } from '@/checkout-instore-legacy/i18n/utils'

import { getWhatsappShareCartLink, getAbsoluteShareLink } from '../utils'
import { shareLink } from '../service'
import { NewSaleButton } from './NewSaleButton'

type CartSuggestionProps = {
  shareCode: string
}

export const CartSuggestion = ({ shareCode }: CartSuggestionProps) => {
  const intl = useIntl()
  const [openMessage, setOpenMessage] = useState(false)
  const [isMountLink, setIsMountLink] = useState(false)
  const [message, setMessage] = useState(
    intl.formatMessage({ id: 'socialShareMessagePlaceHolder' })
  )

  const shareLinkWhatsapp = () => {
    shareLink(getWhatsappShareCartLink(shareCode, message))
  }

  const renderMountLink = () => (
    <div data-testid="shareCartMountShow">
      <ModalTitle id="socialShareCartLabel" />
      <Divider orientation="horizontal" />
      <div className="pv6 flex flex-column ">
        <div className="c-on-base mb3">
          <FormattedMessage id={'socialShareCartSuggestionContent'} />
        </div>
        <span className="c-on-base  ">
          <FormattedMessage id={'socialShareMoreInfo'} />
        </span>

        <div className="mv3">
          <Toggle
            testId="toggle-message"
            label={<FormattedMessage id={'socialShareMessageDetail'} />}
            checked={openMessage}
            onChange={() => setOpenMessage((prev) => !prev)}
          />
        </div>

        {openMessage ? (
          <div className="mv2">
            <Textarea
              dataAttributes={{ testid: 'share-text-area' }}
              label={<FormattedMessage id={'socialShareMessageLabel'} />}
              value={message}
              onChange={(ev: React.ChangeEvent<HTMLInputElement>) =>
                setMessage(ev.target.value)
              }
            />
          </div>
        ) : null}
      </div>

      <Button
        testId="generate-link-button"
        variation="primary"
        onClick={() => {
          setIsMountLink(true)
        }}
        block
      >
        <FormattedMessage id={'socialShareGenerateLink'} />
      </Button>
    </div>
  )

  const renderShareableLink = () => (
    <div data-testid="shareCartLinkShow">
      <ModalTitle id="socialShareReadyLabel" />
      <Divider orientation="horizontal" />
      <div
        style={{ wordBreak: 'break-word' }}
        data-testid="shareable-message"
        className="flex flex-column pv6"
      >
        <span className="c-muted-1 f6 lh-copy">{message}</span>
      </div>

      <div className="flex justify-center mb7" data-testid="qrcode-cart-link">
        <QRCode value={getAbsoluteShareLink(shareCode)} size={200} />
      </div>

      <div className="flex items-baseline f6 mb5 ba b--light-gray br2 bw1">
        <div className="truncate ml3" data-testid="shareable-link">
          {getAbsoluteShareLink(shareCode)}
        </div>
        <div className="flex">
          <ToastConsumer>
            {({ showToast }: any) => (
              <CopyToClipboard
                text={getAbsoluteShareLink(shareCode)}
                onCopy={() =>
                  showToast(getIntlMessage('shareCopySuccessFeedback'))
                }
              >
                <Button variation="tertiary" size="small">
                  <FormattedMessage id={'shareCopyButtonLabel'} />
                </Button>
              </CopyToClipboard>
            )}
          </ToastConsumer>
        </div>
      </div>

      <Button
        testId="share-link-button"
        variation="primary"
        onClick={() => shareLinkWhatsapp()}
        block
      >
        <FormattedMessage id={'shareSubmitButton'} />
      </Button>

      <NewSaleButton />
    </div>
  )

  return isMountLink ? renderShareableLink() : renderMountLink()
}
